import moment from 'moment';
import 'moment/locale/fr';
import userPlaceholder from '../../assets/user.png';

moment.locale('fr');

const calendarOpts = {
  sameDay: "[Aujourd'hui à] LT",
  nextDay: '[Demain à] LT',
  nextWeek: 'dddd [à] LT',
  lastDay: '[Hier à] LT',
  lastWeek: '[Dernier] dddd [à] LT',
  sameElse: 'DD/MM/YYYY',
};

/* Message envoyé (le mien) — affiché à droite */
function InboxMessageItem2({ data }) {
  const isGuest = window.localStorage.getItem('mode') === 'guest';
  const avatar = isGuest
    ? data?.Reservation?.Host?.profile_url || userPlaceholder
    : data?.Reservation?.Invite?.profile_url || userPlaceholder;

  return (
    <div className="d-flex align-items-end justify-content-end gap-2 mb-3">
      {/* Bulle */}
      <div style={{ maxWidth: '70%' }}>
        <div
          className="px-3 py-2 rounded-3 rounded-bottom-end-0"
          style={{ background: '#0d6efd', color: '#fff', wordBreak: 'break-word' }}
        >
          <p className="mb-0" style={{ fontSize: '14px' }}>
            {data.message}
          </p>
        </div>
        <small className="text-muted d-block text-end me-1" style={{ fontSize: '11px' }}>
          {moment(data.createdAt).calendar(null, calendarOpts)}
        </small>
      </div>
      {/* Avatar */}
      <img
        src={avatar}
        alt="avatar"
        style={{
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          objectFit: 'cover',
          flexShrink: 0,
        }}
      />
    </div>
  );
}

export default InboxMessageItem2;
